import { ClientType } from '__generated__/GQL';

const getFieldsToPickByClientType = (
  clientType: ClientType,
): readonly (
  | 'type'
  | 'clientId'
  | 'contacts'
  | 'city'
  | 'companyName'
  | 'country'
  | 'firstName'
  | 'lastName'
  | 'legalRegistrationNumber'
  | 'name'
  | 'street'
  | 'vatId'
  | 'zip'
  | 'email'
  | 'phone'
)[] => {
  return clientType === ClientType.Organization
    ? [
        'city',
        'country',
        'companyName',
        'legalRegistrationNumber',
        'street',
        'type',
        'vatId',
        'zip',
      ]
    : [
        'city',
        'country',
        'email',
        'firstName',
        'lastName',
        'phone',
        'street',
        'type',
        'zip',
      ];
};

export default getFieldsToPickByClientType;
